export function renderDonutChart(
    canvas: HTMLCanvasElement,
    values: number[],
    colors: string[],
): void {
    const rect = canvas.getBoundingClientRect();
    const width = Math.max(1, Math.floor(rect.width));
    const height = Math.max(1, Math.floor(rect.height));
    const dpr = window.devicePixelRatio || 1;
    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);

    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, width, height);

    const total = values.reduce((sum, v) => sum + Math.max(0, v), 0);
    if (total <= 0) return;

    const cx = width / 2;
    const cy = height / 2;
    const radius = Math.min(width, height) * 0.42;
    const inner = radius * 0.62;

    let start = -Math.PI / 2;
    values.forEach((v, idx) => {
        const value = Math.max(0, v);
        const angle = (value / total) * Math.PI * 2;

        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, radius, start, start + angle);
        ctx.closePath();
        ctx.fillStyle = colors[idx % colors.length] || '#5aa6ff';
        ctx.fill();
        start += angle;
    });

    ctx.beginPath();
    ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--terminal-bg-panel').trim() || '#0f141b';
    ctx.arc(cx, cy, inner, 0, Math.PI * 2);
    ctx.fill();
}
